import React, { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Function to format numbers with commas
const formatNumber = (num) => num.toLocaleString();

const Rate = () => {
    const [rates, setRates] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isFading, setIsFading] = useState(false);
    const [defaultCurrency, setDefaultCurrency] = useState("UXB");

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/rates`);
                const data = await response.json();
                if (data?.currencies?.length) {
                    setRates(data.currencies);
                    setDefaultCurrency(data.default_currency_name || "UXB");
                }
            } catch (error) {
                console.error("Error fetching exchange rates:", error);
            }
        };

        fetchRates();
    }, []);

    useEffect(() => {
        if (rates.length === 0) return;

        const interval = setInterval(() => {
            setIsFading(true);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % rates.length);
                setIsFading(false);
            }, 300);
        }, 2000);

        return () => clearInterval(interval);
    }, [rates]);

    return (
        <div className='flex items-center justify-between bg-zinc-200 h-[60px] w-full mb-1'>
            <div className="flex 2xl:w-[1480px] max-xl:w-[1280px] lg:w-[1080px] max-md:w-full mx-auto p-2">
                <div className="flex w-[33%] justify-start text-[16px] cursor-pointer">{defaultCurrency} (UXB)</div>
                <div className="flex w-[33%] justify-center text-[16px] text-zinc-500 cursor-pointer">Rates</div>
                <div
                    className={`flex w-[33%] justify-end text-[16px] cursor-pointer font-semibold transition-opacity duration-300 ${
                        isFading ? "opacity-0" : "opacity-100"
                    }`}
                >
                    {rates.length > 0 ? (
                        `${rates[currentIndex].currency_symbal || rates[currentIndex].currency_short_name} ${formatNumber(rates[currentIndex].currency_value)}`
                    ) : (
                        "Loading..."
                    )}
                </div>
            </div>
        </div>
    );
};

export default Rate;
